import React from 'react';
import Slider from 'react-slick';

interface MainSliderProps {
    images: {id:number, main:boolean, url:string|null}[];
    sliderRef: React.RefObject<Slider | null>;
    gallerySettings: any;
    onImageClick: (index: number) => void;
}

export const MainSlider: React.FC<MainSliderProps> = ({
    images,
    sliderRef,
    gallerySettings,
    onImageClick
}) => (
    <div className='slider slider-for detail-big-car-gallery popup-gallery limit-height-big-photo'>
        <div className='slick-list draggable'>
            <div className="slick-track">
                <Slider {...gallerySettings} ref={sliderRef}>
                    {images.map((img, index) => (
                        <div key={index} className="slick-slide">
                            <a
                                onClick={() => onImageClick(index)}
                                href="#!"
                                className="portfolio-img"
                                tabIndex={0}
                                style={{ width: '100%', display: 'inline-block' }}
                            >
                                <img
                                    className="img-fluid w-100"
                                    alt="Slider Image"
                                    src={img.url ?? ''}
                                />
                            </a>
                        </div>
                    ))}
                </Slider>
            </div>
        </div>
    </div>
);